<template lang="pug">
div(v-if="pessoa")
  el-row.pad5
    el-col(:span="12")
      p
        span.label CPF:
        span &nbsp {{filterNull(pessoa.cpf)}}
    el-col(:span="12")
      p
        span.label Nome:
        span &nbsp {{filterNull(pessoa.nome)}}
    el-col(:span="12" v-if="isProcessoFisicoConjuge")
      p
        span.label Tipo de documento:
        span &nbsp {{filterNull(pessoa.tipoDocumento)}}
    el-col(:span="12" v-if="pessoa.tipoDocumento == 'OUTROS' && isProcessoFisicoConjuge")
      p
        span.label Outros:
        span &nbsp {{filterNull(pessoa.outrosTipoDocumento)}}
    el-col(:span="12")
      p
        span.label RG:
        span &nbsp {{filterNull(pessoa.rg)}}
    el-col(:span="12")
      p
        span.label Órgão expedidor:
        span &nbsp {{filterNull(pessoa.orgaoExpedidor.nome)}}
    el-col(:span="12")
      p
        span.label UF do RG:
        span &nbsp {{getUfRg(pessoa) || '-'}}
    el-col(v-if="!isProcessoFisicoConjuge" :span="12")
      p
        span.label Nacionalidade:
        span &nbsp {{nomeGentilico}}
    el-col(v-if="!isProcessoFisicoConjuge" :span="12")
      p
        span.label Data de nascimento:
        span &nbsp {{filterNullDate(pessoa.dataNascimento)}}
    el-col(:span="12", v-if="isBrasileiro")
      p
        span.label UF da naturalidade:
        span &nbsp {{filterNull(pessoa.ufNaturalidade)}}
    el-col(:span="12", v-if="isBrasileiro")
      p
        span.label Município da naturalidade:
        span &nbsp {{pessoa.naturalidade ? filterNull(pessoa.naturalidade.nome): '-'}}
  slot
</template>
<script>

import _ from 'lodash'
import moment from 'moment'
import gentilicos from '@/constants/gentilico'

export default {

  props: {
    pessoa: {
      Type: Object,
      required: true
    },
    isCadastro: {
      Type: Boolean,
      default: false
    },
    isProcessoFisicoConjuge: {
      Type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {

    nomeGentilico () {
      if (_.isEmpty(gentilicos)) {
        return '-'
      }
      if (this.pessoa.nacionalidade === 'brasil') {
        return 'Brasileiro(a)'
      }
      return _.find(gentilicos,
        gentilico => gentilico.sigla === this.pessoa.nacionalidade).gentilico
    },

    isBrasileiro () {
      return this.pessoa.nacionalidade === 'BR'
    }

  },
  methods: {
    getUfRg (pessoa) {
      return pessoa.orgaoExpedidor.estado ? pessoa.orgaoExpedidor.estado : pessoa.codigo !== null ? pessoa.codigo : '-'
    },

    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    filterNullDate (atributo) {
      return !atributo ? '-' : moment(this.pessoa.dataNascimento).format('DD/MM/YYYY') //eslint-disable-line
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoPessoaFisica.vue